export function isNumber(n: string) {
  return /^-?[\d]+(?:-?\d+)?$/.test(n);
}
